<!-- 首页 -->
<template>
    <div class="index_home_box" style="height: 100%;overflow-y: scroll;">
        <div class="info_one_box" style="background-color: red;">
            <div class="info_top_box">
                <div class="index_content">
                    <div class="index_content_one" v-for="item in 32" :key="item">
                        <el-card shadow="always">
                            工作条目 <br>
                            <span class="index_content_number">{{item}}</span>
                        </el-card>
                    </div>
                </div>
            </div>
        </div>
        <div class="info_one_box">
            <div class="info_top_box">
                <el-alert type="success" effect="dark" :closable="false">
                    <template slot="title">
                        <i class="el-icon-date"></i>今日待办
                    </template>
                </el-alert>
                <div class="index_content_two">
                    <div class="index_content_not" v-for="item in 7" :key="item">
                        <el-badge :value="200" :max="99" class="item">
                            <el-popover placement="top-start" title="2020-02-19" width="200" trigger="hover" content="以下是工作内容">
                                <el-button slot="reference" type="primary" size="medium">
                                    周{{item<7 ? item : '日'}}
                                </el-button>
                            </el-popover>
                        </el-badge>

                    </div>
                </div>
            </div>
        </div>
        <div class="info_one_box info_one_chart_box">
            <div class="info_one_chart">
                <el-alert type="success" effect="dark" :closable="false">
                    <template slot="title">
                        <i class="el-icon-circle-plus-outline"></i>一周入库
                    </template>
                </el-alert>
                <div class="top_chart" id="storageChart">
                    1
                </div>
            </div>
        </div>
        <div class="info_one_box info_one_chart_box">
            <div class="info_one_chart">
                <el-alert type="info" effect="dark" :closable="false">
                    <template slot="title">
                        <i class="el-icon-remove-outline"></i>一周出库
                    </template>
                </el-alert>
                <div class="top_chart" id="deliveryChart">

                </div>
            </div>
        </div>

        <div class="info_two_box" v-for="(values,keys) in dataList" :key="keys">
            <el-card class="info_two_content">
                <div class="warning_title">
                    <el-alert :title="values.name" type="warning" effect="dark" :closable="false">
                    </el-alert>
                </div>
                <div class="info_two_number_box">

                    <template v-for="(listValue,listKeys) in values.list">
                        <div class="info_two_number" v-if="values.list.length>1" :key="listKeys">
                            <div class="info_two_number_text">100</div>
                            <div class="info_two_number_title">{{listValue.numberName}}</div>
                        </div>
                    </template>

                    <template v-for="(listValue,listKeys) in values.list">
                        <div class="info_two_number" v-if="values.list.length<=1" :key="listKeys">
                            <div class="info_two_number_text_two">100</div>
                            <div class="info_two_number_title">{{listValue.numberName}}</div>
                        </div>
                    </template>
                </div>
            </el-card>
        </div>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import * as echarts from "echarts";
export default {
    name: "webIndex",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dataList: [
                { name: "近期预警", list: [{ numberName: "预警总数", value: 999 }] },
                { name: "滞销预警", list: [{ numberName: "预警总数", value: 999 }] },
                {
                    name: "库存养护预警",
                    list: [
                        { numberName: "分类一", value: 999 },
                        { numberName: "分类二", value: 999 },
                    ],
                },
                { name: "缺货预警", list: [{ numberName: "预警总数", value: 999 }] },
                {
                    name: "单位证照预警",
                    list: [{ numberName: "预警总数", value: 999 }],
                },
                {
                    name: "品种证照预警",
                    list: [{ numberName: "预警总数", value: 999 }],
                },
                {
                    name: "设备养护预警",
                    list: [{ numberName: "预警总数", value: 999 }],
                },
                {
                    name: "超账期预警",
                    list: [
                        { numberName: "总额数", value: 999 },
                        { numberName: "客户数", value: 999 },
                    ],
                },
                {
                    name: "付款预警",
                    list: [
                        { numberName: "总额数", value: 999 },
                        { numberName: "客户数", value: 999 },
                    ],
                },
                {
                    name: "合同完成预警",
                    list: [{ numberName: "预警总数", value: 999 }],
                },
                { name: "不合格预警", list: [{ numberName: "预警总数", value: 999 }] },
                { name: "出库超时预警", list: [{ numberName: "条目数", value: 999 }] },
            ],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getWeekTest() {
            var ss = this.$moment().weekday(0);
        },

        echarOne() {
            var chartDom = document.getElementById("storageChart");
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                xAxis: {
                    type: "category",
                    data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
                },
                color: ["#67C23A"],
                yAxis: {
                    type: "value",
                },
                grid: {
                    x: 50,
                    y: 20,
                    x2: 20,
                    y2: 20,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#283b56",
                        },
                    },
                },
                series: [
                    {
                        data: [120, 200, 150, 80, 70, 110, 130],
                        type: "bar",
                        barWidth: 40,
                    },
                ],
            };

            option && myChart.setOption(option);
        },

        echarTwo() {
            var chartDom = document.getElementById("deliveryChart");
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                xAxis: {
                    type: "category",
                    data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
                },
                color: ["#909399"],
                yAxis: {
                    type: "value",
                },
                grid: {
                    x: 50,
                    y: 20,
                    x2: 20,
                    y2: 20,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#283b56",
                        },
                    },
                },
                series: [
                    {
                        data: [120, 200, 150, 80, 70, 110, 130],
                        type: "bar",
                        barWidth: 40,
                    },
                ],
            };

            option && myChart.setOption(option);
        },
        getPageMenuList(test) {
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getWeekTest();
        // var _this = this
        // //这里可放到全局
        // window.getPageMenuList = function() {
        // 	return _this.getPageMenuList()
        // }
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.echarOne();
        this.echarTwo();
        window.getPageMenuList = this.getPageMenuList;
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.index_home_box {
    height: 100%;
    overflow-y: scroll;
}
.info_top_box {
    height: 100%;
    width: 100%;
    display: flex !important;
    flex-direction: column !important;
}
.info_one_chart_box {
    height: 330px !important;
}
.info_one_chart {
    height: 100%;
    width: 100%;
    display: flex !important;
    flex-direction: column !important;
}
.info_one_chart i {
    font-size: 18px;
    margin-right: 1rem;
}

.info_top_box i {
    font-size: 18px;
    margin-right: 1rem;
}

.top_chart {
    /* background-color: #000066; */
    flex: 1;
    overflow: hidden;
}
.info_two_number {
    display: inline-block;
    padding: 0 0.5rem;
}
.info_two_number_title {
    color: #e6a23c;
}
.info_two_number_text {
    /* padding: 1rem; */
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    background-color: #e6a23c;
    display: inline-block;
    margin: 1rem auto;
    border-radius: 100%;
    font-size: 1.2rem;
    font-weight: bold;
    color: #ffffff;
}
.warning_title {
    text-align: left;
}
.info_two_content {
    height: 100%;
    padding: 0 1rem;
}
.info_two_number_box {
    text-align: center;
}
.info_one_box {
    width: 50%;
    display: inline-block;
    height: 180px;
    border-bottom: 1px solid #012534;
    padding: 1rem;
}
.index_content_two {
    flex: 1;
    height: 100%;
    width: 100%;
    overflow: hidden;
}
.info_one_box:nth-child(odd) {
    border-right: 1px solid #012534;
}
.info_two_box {
    width: 25%;
    display: inline-block;
    height: 240px;
    /* border-bottom: 1px solid #012534; */
    padding: 0.5rem;
    /* border-right: 1px solid #012534; */
}
.index_title {
    background-color: #409eff;
    color: #ffffff;
    padding: 0 0.5rem;
    height: 30px;
    line-height: 30px;
    width: 100%;
}
.index_content {
    flex: 1;
    height: 100%;
    width: 100%;
    /* overflow:hidden; */
    overflow-y: scroll;
}

.index_content_number {
    color: red;
    font-size: 20px;
    font-weight: bold;
}
.index_content_one {
    /* flex:1; */
    width: 200px;
    height: 100%;
    display: inline-table;
    padding: 0.5rem;
    text-align: center;

    /* float: left; */
    /* display: flex; */
    /* flex:1; */
}
.index_content_not {
    margin-top: 40px;
    width: 14.25%;
    display: inline-block;
}
.el-card__body {
    padding: 15px 0;
}
.info_two_number_text_two {
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    background-color: #409eff;
    display: inline-block;
    margin: 1rem auto;
    /* border-radius: 100%; */
    font-size: 1.2rem;
    font-weight: bold;
    color: #ffffff;
    -moz-box-shadow: 0px 0px 5px 2px #409eff;
    -webkit-box-shadow: 0px 0px 5px 2px #409eff;
    box-shadow: 0px 0px 5px 2px #409eff;
    border-radius: 1rem;
}
</style>